const enums = {
  jobType: {
    label: "Job Type",
    patrol: "Patrol",
    tag: "Tag",
    boot: "Boot",
    tow: "Tow",
    doNotTow: "Do Not Tow",
    none: "All Jobs",
  },
  status: {
    label: "Status",
    pending: "Pending",
    active: "Active",
    disabled: "Disabled",
  },
  propertyType: {
    label: "Property Type",
    residential: "Residential",
    commercial: "Commercial",
    apartments: "Apartments",
  },
  phoneType: {
    label: "Phone Type",
    mobile: "Mobile",
    home: "Home",
    work: "Work",
    day: "Day",
    night: "Night",
    emergency: "Emergency",
    fax: "Fax",
  },
  ruleType: {
    label: "Rule Type",
    patrol: "Patrol",
    tag: "Tag",
    boot: "Boot",
    tow: "Tow",
    doNotTow: "Do Not Tow",
  },
  roles: {
    label: "Roles",
    superAdmin: "Super Admin",
    admin: "Admin",
    driver: "Driver",
    dispatcher: "Dispatcher",
    propertyManager: "Property Manager",
    yardManager: "Yard Manager",
    sales: "Sales",
    accounting: "Accounting",
  },
  dayOfWeek: {
    label: "Day",
    sunday: "Sunday",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
  },
  serviceStatus: {
    pass: "Pass",
    warn: "Warn",
    fail: "Fail",
    offline: "Offline",
  },
  permitStatus: {
    active: "Active",
    disabled: "Disabled",
    pending_registration: "Pending Registration",
    pending_approval: "Pending Approval",
    pending_payment: "Pending Payment",
    expired: "Expired",
    approval_expired: "Approval Expired",
  },
  timeUnit: {
    label: "Unit of Time",
    minute: "minute",
    minute_one: "minute",
    minute_other: "minutes",
    hour: "hour",
    hour_one: "hour",
    hour_other: "hours",
    day: "day",
    day_one: "day",
    day_other: "days",
    month: "month",
    month_one: "month",
    month_other: "months",
    year: "year",
    year_one: "year",
    year_other: "years",
    week: "week",
    week_one: "week",
    week_other: "weeks",
    forever: "forever",
  },
  permitFeeType: {
    label: "Fee Type",
    oneTime: "Flat Rate",
    perUnit: "Per Unit",
    percentage: "Percent",
  },
  inviteStatus: {
    pending: "Pending",
    sent: "Sent",
    failed: "Failed",
    none: "None",
  },
  permitTransactionStatus: {
    none: "Unpaid",
    paid: "Paid",
    refunded: "Refunded",
    hold: "Hold",
    cancelled: "Cancelled",
  },
};

export default enums;
